/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaCategory,
    MediaCategoryFromJSON,
    MediaCategoryFromJSONTyped,
    MediaCategoryToJSON,
} from './MediaCategory';

/**
 * 
 * @export
 * @interface MediaCategoriesResponseAllOfData
 */
export interface MediaCategoriesResponseAllOfData {
    /**
     * メディアタイプ一覧
     * @type {Array<MediaCategory>}
     * @memberof MediaCategoriesResponseAllOfData
     */
    mediaTypes: Array<MediaCategory>;
    /**
     * 種類一覧
     * @type {Array<MediaCategory>}
     * @memberof MediaCategoriesResponseAllOfData
     */
    mediaIndustries: Array<MediaCategory>;
    /**
     * エリア一覧
     * @type {Array<MediaCategory>}
     * @memberof MediaCategoriesResponseAllOfData
     */
    mediaRegions: Array<MediaCategory>;
}

export function MediaCategoriesResponseAllOfDataFromJSON(json: any): MediaCategoriesResponseAllOfData {
    return MediaCategoriesResponseAllOfDataFromJSONTyped(json, false);
}

export function MediaCategoriesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaCategoriesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaTypes': ((json['media_types'] as Array<any>).map(MediaCategoryFromJSON)),
        'mediaIndustries': ((json['media_industries'] as Array<any>).map(MediaCategoryFromJSON)),
        'mediaRegions': ((json['media_regions'] as Array<any>).map(MediaCategoryFromJSON)),
    };
}

export function MediaCategoriesResponseAllOfDataToJSON(value?: MediaCategoriesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_types': ((value.mediaTypes as Array<any>).map(MediaCategoryToJSON)),
        'media_industries': ((value.mediaIndustries as Array<any>).map(MediaCategoryToJSON)),
        'media_regions': ((value.mediaRegions as Array<any>).map(MediaCategoryToJSON)),
    };
}

